/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
import {FC, useEffect, useState} from 'react'
import Highcharts from 'highcharts/es-modules/masters/highcharts.src'
import "highcharts/es-modules/masters/highcharts-more.src"
import "highcharts/es-modules/masters/modules/exporting.src"
import "highcharts/es-modules/masters/modules/offline-exporting.src"
import "highcharts/es-modules/masters/modules/export-data.src"
import "highcharts/es-modules/masters/modules/sankey.src";
import HighchartsReact from 'highcharts-react-official'
import { getNameByISO3, shortenLargeNumber } from "../../../../libs/misc";
import * as _ from 'lodash'
import { HIGHCHART_COLORS } from '../../../../libs/constant'
import { Spinner } from 'react-bootstrap'


type TradePotentialChartProps = {
  data?:any
}

const TradePotentialChart:FC<TradePotentialChartProps> = ({
  data
}) => {
  const [isLoading, setIsLoading] = useState(true)
  const [chartData, setChartData] = useState<any[]|null>(null)
  
  const highchartOptions = {
    chart:{
      type: 'sankey',
      zoomType: 'x',
      marginTop: 80,
      marginBottom: 40,
    },
    tooltip: {
      headerFormat: '',
      useHTML: true,
      formatter: function (this:any) {
        if(!this.point.isNode){
          //Tooltip for Line
          return `
            <div style="text-align: center;">
              <b>${getNameByISO3(this.point.from)} &#8594; ${this.point.to?getNameByISO3(this.point.to):this.point.to}: ${shortenLargeNumber(this.point.weight)}</b>
            </div>
          `
        }else if(this.point.id==='KHM'){
          //Tooltip for Node From
          return `
            <div style="text-align: center;">
              <b>${this.point.name}</b>
            </div>
          `
        }else{
          // Tooltip for Node To
          return `
            <div style="text-align: center;">
              <b>${this.point.name}</b>
              <table style="text-align: left;">
                <tr>
                  <th>Value</th>
                  <td>:</td>
                  <td>
                    ${new Intl.NumberFormat('en-US',{ 
                      style: 'currency', 
                      currency: 'USD',
                      maximumFractionDigits: 0
                    }).format(this.point.total_value)}
                  </td>
                </tr>
                <tr>
                  <th>Quantity</th>
                  <td>:</td>
                  <td>${new Intl.NumberFormat().format(this.point.qty)}</td>
                </tr>
                <tr>
                  <th>Bound Tariff</th>
                  <td>:</td>
                  <td>${this.point.bound!=='N/A'?(this.point.bound).toFixed(2)+'%':this.point.bound}</td>
                </tr>
                <tr>
                  <th>MFN Tariff</th>
                  <td>:</td>
                  <td>${this.point.mfn!=='N/A'?this.point.mfn.toFixed(2)+'%':this.point.mfn}</td>
                </tr>
                <tr>
                  <th>Preferential Tariff</th>
                  <td>:</td>
                  <td>${this.point.pref!=='N/A'?this.point.pref.toFixed(2)+'%':this.point.pref}</td>
                </tr>
              </table>
            </div>
          `
        }
      }
    },
    title:{
      text: data && data[0] 
        ? (data[0].flow === 2 
          ? `Top Cambodia's Export Destinations of Commodity ${data[0].hs} in ${data[0].year}` 
          : `Top Cambodia's Import Sources of Commodity ${data[0].hs} in ${data[0].year}`) 
        : 'No Data Found', // Default or loading title
        style: {
          fontSize: '16px'
        }
    },
    series: [{
      keys: ['from', 'to', 'weight'],
      data: [],
      nodes: [],
      minLinkWidth: 5,
      nodeWidth:25,
    }],
    credits:{
      enabled: true,
      text: `Data source: UN Comtrade`,
      href: '#',
      position: {
        align: 'right'
      }
    },
    // exporting: {
    //   enabled: true
    // },
  };

  const [chartOptions, setChartOptions] = useState(highchartOptions)
  
  // Cleanup function to reset the state when the component is unmounted 
  useEffect(()=>{
    setChartData([])
    setIsLoading(true)
    return () => {
      setChartData([])
      setIsLoading(true)
    };
  },[])

  useEffect(()=>{
    setChartData(data)
    // eslint-disable-next-line array-callback-return
    highchartOptions.series[0].data = data?.map((el)=>{
      if(el.flow===2){
        return [el.rep, el.par, el.val]
      }else if(el.flow===1){
        return [el.par, el.rep, el.val]
      }
    })

    // Function to get node data from each element in data array
    const getNodeData = (el, idx) => ({
      id: el.par,
      name: getNameByISO3(el.par),
      bound: el.bound_tariff,
      mfn: el.mfn_tariff,
      pref: el.preff_tariff,
      qty: el.qty,
      total_value: el.val,
      color: HIGHCHART_COLORS[idx+1]
    });

    // Map over the data to generate nodes
    const nodes = data?.map(getNodeData) || [];

    // Push the Cambodia node
    nodes.push({
      id: 'KHM',
      name: 'Cambodia',
      color: HIGHCHART_COLORS[0]
    });

    // Assign nodes to highchartOptions
    highchartOptions.series[0].nodes = nodes;
    setChartOptions(highchartOptions)
    setIsLoading(false)
  },[data])

  return (
    <>
    {!isLoading && (data?.length??0)>0 ? (
      <HighchartsReact
        highcharts={Highcharts}
        options={chartOptions}
        className='mt-5'
      />
    ):(
      <div className="d-flex align-items-center justify-content-center" style={{ height: '50vh' }}>
        <Spinner animation="border" role="status" variant="primary" className="me-3" />
        <div className="loading-text">
          Loading
          <span className="dot">.</span>
          <span className="dot">.</span>
          <span className="dot">.</span>
        </div>
      </div>
    )}
    </>
  )
}

export {TradePotentialChart}

